import { cn } from "../../utils/cn";
import { LogoVariant } from "./LogoVariant";

const VARIANTS = {
  [LogoVariant.DEFAULT]: {
    topHalf: "#FF6940",
    bottomHalf: "#F78B67",
  },
  [LogoVariant.WHITE]: {
    topHalf: "#ffffff",
    bottomHalf: "rgba(255, 255, 255, 0.6)",
  },
};

export function LogoIcon({
  className,
  variant,
}: {
  className?: string;
  variant?: LogoVariant;
}) {
  const _variant = variant ?? LogoVariant.DEFAULT;
  return (
    <div className={cn("w-full h-full", className)}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 1417.21 1603.72"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(0, 0)" fillRule="nonzero">
            <path
              d="M1417.22,506.1 C1417.22,616.57 1381.8,718.8 1321.81,801.95 C1229.94,674.57 1080.24,591.72 911.2,591.72 C689.85,591.72 486.92,670.6 329.07,801.95 C128.04,634.7 0,382.71 0,100.79 L0,0 L911.21,0 C1050.92,0 1177.45,56.66 1269.04,148.26 C1360.54,239.76 1417.22,366.38 1417.22,506.1"
              fill={VARIANTS[_variant].topHalf}
            />
            <path
              d="M1417.22,1097.72 C1417.22,1237.44 1360.53,1363.96 1269.03,1455.47 C1177.45,1547.07 1050.91,1603.73 911.2,1603.73 L0,1603.73 L0,1502.94 C0,1221.02 128.04,969.03 329.08,801.96 C486.94,933.13 689.86,1012.11 911.21,1012.11 C1080.25,1012.11 1229.85,929.25 1321.82,801.96 C1381.81,885.11 1417.22,987.34 1417.22,1097.73"
              fill={VARIANTS[_variant].bottomHalf}
            />
          </g>
        </g>
      </svg>
    </div>
  );
}
